/* src/app/home/home.component.scss */
.dashboard-header {
  margin-bottom: 30px;
}
@media screen and (max-width: 739px) {
  .dashboard-header {
    margin-left: 15px;
  }
}
.separator {
  display: flex;
  align-items: center;
  text-align: center;
}
.separator::before,
.separator::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #000;
}
.separator::before {
  margin-right: 0.25em;
}
.separator::after {
  margin-left: 0.25em;
}
.status-filter {
  position: relative;
  margin-bottom: 0.5rem;
}
.status-filter.selected {
  color: white;
  background-color: #02857e;
  border: thin #02857e solid;
}
.status-filter.attention-needed {
  background-color: #F68B20;
}
.status-filter span {
  font-size: 14px;
}
.status-filter strong {
  white-space: normal;
  font-size: 12px;
}
.status-filter strong.no-white-space {
  white-space: unset;
}
input[type=checkbox] {
  opacity: 0;
  position: fixed;
}
.up-and-down-sort {
  box-shadow: none;
  background-color: white;
  border: thin #757575 solid;
  align-self: flex-end;
  margin-left: 12px;
}
.up-and-down-sort:before {
  font-family: upsicons, fantasy !important;
  content: "\e619" !important;
}
.filter-button {
  box-shadow: none;
  background-color: white;
  top: 29px;
  border: thin #757575 solid;
  height: 100%;
  align-self: flex-end;
  margin-left: 12px;
}
.filter-button:before {
  font-family: upsicons, fantasy !important;
  content: "\e6cf" !important;
}
.search.icon:before {
  font-family: upsicons, fantasy !important;
  content: "\e668" !important;
  color: #FFF;
}
.clear.icon:before {
  font-family: upsicons, fantasy !important;
  content: "\e67b" !important;
  color: #FFF;
}
.location-user-button {
  padding: 10px 30px;
}
.add-request-button {
  padding: 10px 27px;
}
.add-request-button:before {
  font-family: upsicons, fantasy !important;
  content: "\e65b" !important;
  color: white;
  margin-right: 8px;
}
.export-requests-button {
  padding: 10px 27px;
}
.export-requests-button:before {
  font-family: upsicons, fantasy !important;
  content: "\e63a" !important;
  color: white;
  margin-right: 8px;
}
.export-requests-button:disabled {
  background-color: #E8E8E6 !important;
  color: #BEBEBE !important;
  border: none !important;
}
.notification-settings-button {
  padding: 10px 40px;
}
.request-buttons,
.management-buttons {
  white-space: nowrap;
}
.management-buttons {
  display: flex;
  gap: 12px;
  margin-top: 12px;
  margin-bottom: 12px;
}
.request-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-self: flex-end;
  gap: 12px;
  margin-right: 20px;
}
.buttons-container {
  display: grid;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
}
.buttons-container :host ::ng-deep button {
  width: fit-content;
}
.request-list-container {
  margin-right: 15px;
  margin-left: 32px;
  width: 100%;
}
.btn-ups {
  color: #252525;
  background-color: white;
  border: thin #6f6f6f solid;
  height: 110px;
  width: 100px !important;
  white-space: nowrap;
  display: inline-block;
}
.btn-ups-gray {
  color: white;
  background-color: #6f6f6f;
  border: thin #252525 solid;
  height: 110px;
  width: 100px !important;
  white-space: nowrap;
}
.date-range-picker-container {
  min-width: 377px;
}
.location-list-container {
  min-width: 377px;
}
.alert-date-range {
  border: solid 1px #F68B20;
  border-radius: 8px;
  margin-top: 10px;
  margin-bottom: 16px;
  height: 57px;
  position: relative;
  font-size: 12px;
  color: #000;
  vertical-align: top;
}
.alert-date-range > strong:before {
  font-family: upsicons, fantasy !important;
  content: "\e60a" !important;
  color: #F68B20;
  margin: 0px 13px;
  font-size: 24px;
}
.alert-date-range > .close {
  color: #000;
  position: absolute;
  top: 4px;
  right: 11px;
  padding: 0px;
  outline: none;
}
.button-meatball {
  position: relative;
}
.meatball {
  position: absolute;
  top: -14px;
  right: -14px;
  font-size: 12px;
  font-weight: 700;
  vertical-align: top;
  text-align: center;
  color: #000000;
  z-index: 10;
}
.comments-container {
  max-width: 377px;
}
.comments-indicator {
  height: 28px;
  width: 28px;
  background-color: #F88C00;
  border-radius: 50%;
  text-align: center;
  position: absolute;
  top: -6px;
  right: -6px;
}
.comments-indicator.icon::after {
  font-family: upsicons, fantasy !important;
  content: "\e62f" !important;
  color: #000000;
  font-size: 20px;
}
.comments-label {
  font-family:
    "Roboto",
    Tahoma,
    Helvetica,
    sans-serif;
  font-size: 14px;
  font-weight: 400;
  margin-top: -13px;
  margin-bottom: 12px;
  color: #F68B20;
}
.filter-form-lg {
  margin-top: 15px;
}
.showFilters {
  display: block !important;
}
button.active {
  color: white;
  background-color: #00857D;
}
button.hover {
  color: white;
  background-color: #00857D;
}
input[type=text] {
  border-radius: 0px;
  border-color: #979797;
}
:host ::ng-deep .date-picker {
  width: 160px;
}
:host ::ng-deep .date-picker .input-group {
  max-width: 160px;
}
:host ::ng-deep .date-picker .input-group input[type=text] {
  max-width: 126px;
  font-size: 14px;
  padding: 10px;
}
:host ::ng-deep .date-picker .input-group .calendar-btn {
  height: 35px;
  width: 35px;
  padding: 0;
}
.home-container {
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr;
  max-width: 1580px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}
.dashboard {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto auto auto auto auto auto auto auto auto 1fr auto;
  grid-template-areas: "buttons" "dates" "comment-messages" "location-toggle" "locations" "request-toggle" "request-buttons" "status" "filter" "requests" "bottom";
  position: relative;
  column-gap: 4px;
  margin-left: auto;
  margin-right: auto;
  min-width: 360px;
  overflow-y: clip;
  width: 100%;
  min-height: 750px;
}
.view-bottom {
  grid-area: bottom;
  position: sticky;
  bottom: 0px;
  height: 0px;
}
.section-dates {
  grid-area: dates;
}
@media screen and (min-width: 740px) {
  .section-dates {
    padding-left: 22px;
  }
}
.section-comment-messages {
  grid-area: comment-messages;
}
@media screen and (max-width: 739px) {
  .section-comment-messages {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
@media screen and (min-width: 740px) {
  .section-comment-messages {
    padding-bottom: 17px;
    height: min-content;
  }
}
.section-toggle {
  display: block;
  border: solid 1px #757575;
  border-right: none;
  border-left: none;
  height: 51px;
  line-height: 51px;
  padding-left: 16px;
  background-color: #F2F2F2;
  color: #242424;
  position: sticky;
  top: 0px;
  z-index: 100;
}
.show-section-indicator {
  font-size: 16px;
  font-weight: 700;
}
.show-section-indicator:not(.active)::after {
  font-family: "upsicons", fantasy !important;
  content: "\e65b" !important;
  color: black;
  position: absolute;
  right: 16px;
}
.show-section-indicator.active::after {
  font-family: "upsicons", fantasy !important;
  content: "\e653" !important;
  color: black;
  position: absolute;
  right: 16px;
}
.location-toggle {
  grid-area: location-toggle;
}
.request-toggle {
  grid-area: request-toggle;
}
.section-locations {
  grid-area: locations;
  max-height: 100vh;
  max-height: 100svh;
  margin-bottom: 10px;
  display: none;
  justify-content: center;
  padding-top: 24px;
  padding-bottom: 24px;
}
.section-locations location-list {
  width: 320px;
}
.section-buttons {
  grid-area: buttons;
  padding-right: 23px;
  padding-top: 10px;
}
.section-request-buttons {
  grid-area: request-buttons;
  display: none;
  margin-top: 32px;
  margin-bottom: 32px;
}
.show-request-buttons {
  display: none !important;
}
.section-status {
  grid-area: status;
  display: none;
}
.section-status .request-status-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  height: min-content;
  min-width: 360px;
  justify-content: center;
}
.section-filter {
  grid-area: filter;
  display: none;
  flex-direction: column;
  align-items: center;
}
.section-filter .search {
  display: flex;
}
.section-filter .search input {
  width: 239px;
}
.section-filter .inline-sort {
  display: none !important;
}
.section-filter .sort {
  display: flex;
  position: relative;
  margin-top: 17px;
}
.section-filter .sort ups-select {
  width: 280px;
}
.section-requests {
  grid-area: requests;
  padding-top: 32px;
  display: none;
  flex-direction: column;
  align-items: center;
}
@media (max-width: 740px) {
  .show-mobile-requests {
    display: block !important;
  }
}
@media (min-width: 740px) {
  .dashboard {
    grid-template-columns: 340px 1fr;
    grid-template-rows: auto auto auto auto 1fr auto;
    grid-template-areas: "dates buttons" "comment-messages status" "locations status" "locations filter" "locations requests" "bottom bottom";
    margin-left: 0;
    margin-right: 0;
    padding-bottom: 0px;
    overflow: unset;
  }
  .section-locations {
    position: sticky;
    top: 0px;
    margin-bottom: 0px;
    border-bottom: none;
    display: block;
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .section-locations location-list {
    width: auto;
  }
  .section-status {
    display: block;
  }
  .section-status .request-status-buttons {
    min-width: 400px;
    justify-content: flex-start;
  }
  .section-filter {
    display: block;
  }
  .show-request-buttons {
    display: flex !important;
  }
  .section-toggle {
    display: none;
  }
  .adjust-request-button-spacing {
    margin-top: 63px;
  }
  .section-dates {
    padding-left: 0px;
  }
  .section-requests {
    display: block;
  }
  .btn-ups {
    width: 120px !important;
  }
  .btn-ups-gray {
    width: 120px !important;
  }
  .status-filter strong {
    font-size: 14px;
  }
  .up-and-down-sort {
    height: 100%;
  }
  .location-user-button {
    padding: 10px 40px;
  }
  .management-buttons {
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  .request-buttons {
    margin-right: 0px;
  }
  .buttons-container {
    flex-direction: column !important;
    align-items: flex-end;
    padding-bottom: 24px;
  }
}
@media (max-width: 991px) {
  .btn-ups-gray,
  .btn-ups {
    font-size: 10px;
    width: calc((100vw - 44px) / 10);
  }
  .filter-form-lg {
    display: none;
  }
  .filter-form-md {
    display: none;
  }
  filter-form.filter-form-md.showFilters {
    display: block !important;
  }
  .buttons-container {
    flex-direction: row;
    justify-content: flex-end;
    width: 100%;
  }
}
@media (min-width: 992px) {
  .btn-ups-gray,
  .btn-ups {
    font-size: 10px;
    width: calc((100vw - 60px) / 9);
  }
  .filter-form-md {
    display: none;
  }
  .filter-form-lg {
    display: none;
  }
  filter-form.filter-form-lg.showFilters {
    display: block !important;
  }
}
@media screen and (max-width: 1000px) {
  .buttons-container {
    flex-direction: column;
    align-items: flex-end;
  }
  .comments-container {
    max-width: 240px;
  }
  .location-list-container {
    min-width: 240px;
  }
  .date-range-picker-container {
    min-width: 240px;
  }
}
@media screen and (max-width: 1000px) and (min-width: 740px) {
  .date-range-picker-container {
    max-width: 240px;
  }
}
@media screen and (max-width: 1000px) {
  .management-buttons {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
  }
}
@media (min-width: 1280px) {
  .dashboard {
    grid-template-columns: 370px 1fr;
  }
  .section-buttons {
    padding-right: 10px;
  }
  .management-buttons {
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
    flex-flow: column;
  }
  .buttons-container {
    flex-direction: row !important;
    align-items: flex-end;
  }
}
@media (min-width: 1510px) {
  .dashboard {
    grid-template-columns: 370px 1fr;
    grid-template-rows: auto auto auto auto 1fr auto;
    grid-template-areas: "dates buttons " "comment-messages status" "locations status" "locations filter" "locations requests" "bottom bottom bottom";
    margin-left: 0;
    margin-right: 0;
    padding-bottom: 0px;
  }
  .section-status {
    margin-top: 20px;
  }
  .section-status .request-status-buttons {
    flex-wrap: nowrap;
  }
  .section-status .status-name {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .request-buttons {
    flex-flow: row;
    flex-wrap: nowrap;
  }
  .management-buttons {
    flex-flow: row;
  }
  .management-buttons button {
    padding: 10px 40px;
  }
  .section-filter .inline-buttons {
    display: flex;
    flex-direction: row;
    gap: 32px;
    margin-top: 14px;
  }
  .section-filter button {
    height: 38px;
  }
  .section-filter .inline-sort {
    display: flex !important;
  }
  .section-filter .sort {
    margin-top: 0px;
  }
  .section-filter .sort:not(.inline-sort) {
    display: none !important;
  }
  .section-buttons {
    padding-right: 0px;
    padding-top: 25px;
  }
  .section-request-buttons {
    padding-right: 0px;
    padding-top: 16px;
    grid-area: request-buttons;
  }
  .buttons-container {
    flex-direction: row !important;
    align-items: center;
    width: 100%;
  }
  .btn-ups {
    color: #252525;
    background-color: white;
    border: thin #6f6f6f solid;
    height: 110px;
    width: 10% !important;
    white-space: nowrap;
    display: inline-block;
    padding: 0px;
    max-width: 125px !important;
  }
  .btn-ups-gray {
    color: white;
    background-color: #6f6f6f;
    border: thin #252525 solid;
    height: 110px;
    width: 10% !important;
    white-space: nowrap;
    max-width: 125px !important;
  }
}
@media (min-width: 1880px) {
  .dashboard {
    grid-template-columns: 377px 1fr;
    column-gap: 32px;
  }
  .buttons-container {
    flex-direction: row;
    align-items: center;
    width: 100%;
    margin-right: 15px;
    margin-left: 0px;
  }
  .btn-ups {
    color: #252525;
    background-color: white;
    border: thin #6f6f6f solid;
    height: 110px;
    width: 125px !important;
    white-space: nowrap;
    display: inline-block;
  }
  .btn-ups-gray {
    color: white;
    background-color: #6f6f6f;
    border: thin #252525 solid;
    height: 110px;
    width: 125px !important;
    white-space: nowrap;
  }
  .section-filter .inline-buttons {
    justify-content: flex-end;
    margin-right: 25px;
  }
  .section-requests {
    padding-top: 1rem;
  }
}
@media (min-width: 1880px) {
  .btn-ups {
    width: 194px;
    font-size: 14px;
  }
  .btn-ups-gray {
    width: 158px;
    font-size: 14px;
  }
}
/*# sourceMappingURL=home.component.css.map */
